import React from "react";
import { stats } from "../mock";
import { useReveal, useCountUp } from "../hooks/useReveal";

const StatItem = ({ value, suffix, label, active }) => {
  const n = useCountUp(value, active);
  return (
    <div className="text-center">
      <div className="font-head text-5xl sm:text-6xl font-bold text-gold leading-none">
        {n}{suffix}
      </div>
      <p className="text-white/70 text-sm mt-3 tracking-wide uppercase">{label}</p>
    </div>
  );
};

const Stats = () => {
  const [ref, inView] = useReveal({ threshold: 0.3 });
  return (
    <section className="bg-navy-2 text-white">
      <div ref={ref} className="max-w-6xl mx-auto px-4 py-16 grid grid-cols-2 lg:grid-cols-4 gap-10">
        {stats.map((s) => (
          <StatItem key={s.label} {...s} active={inView} />
        ))}
      </div>
    </section>
  );
};

export default Stats;
